import { Injectable } from '@angular/core'

@Injectable()
export class SoundService {
    isSoundDisabled = false
    private auctionsMuted: number[] = []

    constructor() {
        this.isSoundDisabled = localStorage.getItem('isSoundDisabled') === 'true'
    }

    setSoundStatus(status: boolean): void {
        this.isSoundDisabled = status
    }

    checkAuctionSound(auctionId: number): void {
        this.auctionsMuted = JSON.parse(localStorage.getItem('auctionsMuted') || '[]')
        const exists = this.auctionsMuted.find((a) => a.toString() === auctionId.toString())
        this.isSoundDisabled = !!exists
    }

    toggleAuctionSound(auctionId: number): void {
        this.isSoundDisabled = !this.isSoundDisabled
        this.auctionsMuted = JSON.parse(localStorage.getItem('auctionsMuted') || '[]')
        if (!this.auctionsMuted.includes(auctionId) && this.isSoundDisabled) {
            this.auctionsMuted.push(auctionId)
        } else {
            this.auctionsMuted = this.auctionsMuted.filter((a) => a !== auctionId)
        }
        localStorage.setItem('auctionsMuted', JSON.stringify(this.auctionsMuted))
    }

    playSound(soundFile: string) {
        if (this.isSoundDisabled) return

        const sound = new Audio()
        sound.src = `../../../assets/sounds/${soundFile}.mp3`

        let playPromise = sound.play()

        if (playPromise !== undefined) {
            playPromise.then().catch(() => {
                // Do nothing and hide the error from the console so it's not captured by Sentry
            })
        }
    }
}
